<template lang="html">
    <div class="popup__tabs">
        <div class="tabs">
            <ul class="tabs__list">
                <li class="tabs__item" :class="{ active : mode == 'list' }" @click.prevent="mode = 'list'" >Списком</li>
                <li class="tabs__item" :class="{ active : mode == 'map' }" @click.prevent="mode = 'map'" >На карте</li>
            </ul>
        </div>
    </div>
    <!-- Начиная с 768px вид переключается табами -->
    <div class="popup__map" :class="{ active : mode == 'map' }">
        <slot name="map" :selectStore="selectStore" :mode="mode" ></slot>
    </div>
    <div class="popup__content" :class="{ active : mode == 'list' }">
        <div class="popup__title">
            <h2 class="popup__title-title">Выберите сервисный центр</h2>
        </div>
        <div class="services-list">
            <slot name="list" :selectStore="selectStore" :mode="mode" ></slot>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';

export default {
    name : 'StoresListMap',
    emits : [ 'selected' ],
    setup (props, { emit }) {
        const mode = ref('map');
        const selectStore = store => {
            emit('selected', store);
        }
        return { selectStore, mode }
    }
}
</script>
